// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"501":"3adff4f9967fadba","3608":"580791a0ebea52cf","8479":"d4dc972bbf692a05","9410":"bfae1b46c3da15a1"}[chunkId] + ".js";
};